export default function mapBackendErrors(fieldErrors) {
    let globalError = null;
    const backendErrors = {};
    if (fieldErrors != null) {
        for (const fieldError of fieldErrors) {
            if (fieldError.field === "") {
                globalError = fieldError.messages;
            }
            else {
                backendErrors[fieldError.field] = fieldError.messages;
            }
        }
    }
    return {
        globalError,
        backendErrors
    };
}



// WEBPACK FOOTER //
// ./src/assets/scripts/utils/mapBackendErrors.ts